import React, { FC } from 'react'

export type EditAssignmentsProps = {}

export const EditAssignments: FC<EditAssignmentsProps> = () => {
  return (
    <>
      <div>Edit Assignments</div>
    </>
  )
}
